import { styled } from '@linaria/react';
import { colors, fonts } from '../../theme/tokens';

export const StyledTextArea = styled.textarea`
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  padding: 10px 12px;
  border: 1px solid ${colors.borderGrey};
  border-radius: 8px;
  color: ${colors.fontPrimary};
  outline: none;
  width: 100%;
  box-sizing: border-box;
  resize: vertical;
  min-height: 80px;

  &::placeholder {
    color: ${colors.grey};
  }

  &:focus {
    border-color: ${colors.primary};
  }

  &[aria-invalid='true'] {
    border-color: ${colors.error};
  }
`;
